<template>
  <div>
    <section class="photoList list10sen">
      <div class="inner2">
        <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[0], verticalM: !isHorizontal[0] }">
          <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0])"><img class="exhPhotoImg" :src="winningWorks[0].imageUrlS" alt="" @load="(event) => loadHandler(event, 0)" /></a>
          <div class="exhPhotoInfo">
            <h2 class="photoTitle">{{winningWorks[0].title}}</h2>
            <ul v-if="isCommentaryExists(0)" class="photoCommentary">
              <li v-if="isCommentExists(0)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
              <li v-if="isMovieExists(0)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
            </ul>
          </div><!-- /exhPhotoInfo-->
        </section>
        <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[1], verticalM: !isHorizontal[1] }">
          <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[1])"><img class="exhPhotoImg" :src="winningWorks[1].imageUrlS" alt="" @load="(event) => loadHandler(event, 1)" /></a>
          <div class="exhPhotoInfo">
            <h2 class="photoTitle">{{winningWorks[1].title}}</h2>
            <ul v-if="isCommentaryExists(1)" class="photoCommentary">
              <li v-if="isCommentExists(1)" class="expTxtBtn"><a href="javascript:void(1)" @click.stop="openImageViewer(winningWorks[1], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
              <li v-if="isMovieExists(1)" class="expMovieBtn"><a href="javascript:void(1)" @click.stop="openImageViewer(winningWorks[1], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
            </ul>
          </div><!-- /exhPhotoInfo-->
        </section>
      </div><!-- /inner-->
    </section><!-- /photoList-->
  </div>
</template>

<script>

export default {
  components: {
  },
  props: [
    'winner',
    'openImageViewer'
  ],
  data () {
    return {
      winningWorks: [],
      isHorizontal: {}
    }
  },
  methods: {
    loadHandler (event, index) {
      // 縦位置横位置判定
      if (event.target.naturalWidth >= event.target.naturalHeight) {
        this.$set(this.isHorizontal, index, true)
      } else {
        this.$set(this.isHorizontal, index, false)
      }
    },
    isCommentaryExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction && (
          this.winningWorks[index].winningWorkIntroduction.comment ||
          this.winningWorks[index].winningWorkIntroduction.youtubeUrl
        )
      )
    },
    isCommentExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction &&
        this.winningWorks[index].winningWorkIntroduction.comment
      )
    },
    isMovieExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction &&
        this.winningWorks[index].winningWorkIntroduction.youtubeUrl
      )
    }
  },
  created () {
    this.winningWorks = this.winner.winningWorks
  }
}
</script>
